import {
  PROFILE_ERROR,
  PROFILE_SUCCESS,
  EDIT_PROFILE,
  RESET_PROFILE_STATUS,
  RECEIVED_PROFILE,
  FETCH_PROFILE,
  UPDATE_PROFILE_SWITCH,
  UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_ERROR,
  RESET_UPDATE_PROFILE_STATUS,
} from "./actionTypes";

export const editProfile = (user) => {
  return {
    type: EDIT_PROFILE,
    payload: { user },
  };
};

export const profileSuccess = (msg) => {
  return {
    type: PROFILE_SUCCESS,
    payload: msg,
  };
};

export const profileError = (error) => {
  return {
    type: PROFILE_ERROR,
    payload: error,
  };
};

export const fetchProfile = () => {
  return {
    type: FETCH_PROFILE,
  };
};

export const receivedProfile = (profile) => {
  return {
    type: RECEIVED_PROFILE,
    payload: profile,
  };
};

export const resetProfileStatus = () => {
  return {
    type: RESET_PROFILE_STATUS,
  };
};

export const updateProfileSwitch = (data) => {
  return {
    type: UPDATE_PROFILE_SWITCH,
    payload: data,
  };
};

export const updateProfile = (profileData) => {
  return {
    type: UPDATE_PROFILE,
    payload: profileData,
  };
};

export const updateProfileSuccess = (data) => {
  return {
    type: UPDATE_PROFILE_SUCCESS,
    payload: data,
  };
};

export const updateProfileError = (error) => {
  return {
    type: UPDATE_PROFILE_ERROR,
    payload: error,
  };
};

export const resetUpdateProfileStatus = () => {
  return {
    type: RESET_UPDATE_PROFILE_STATUS,
  };
};
